import axios from "axios";
import AuthService from "../login/auth.service";
import { creditos } from "../../components/generico/utils/UrlAPI";


class PrestamoPreaprobadoService {

  /**
   * @author mbareiro
   * Obtiene las sucursales para el desembolso
   * @returns 
   */
  async getSucursalDesembolso() {
    var config = {
      method: "get",
      url: creditos + 'creditos-preaprobados/sucursales?canal=WEB',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      
    };

    return await axios(config);
  }

 

  /**
   * @author mbareiro
   * Obtiene los plazos
   * @returns 
   */
   async getPlazos() {
    var config = {
      method: "get",
      url: creditos + 'creditos-preaprobados/plazos?canal=WEB',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      
    };

    return await axios(config);
  }
  
  /**
   * @author mbareiro
   * Obtiene los plazos
   * @returns 
   */
  async getPlazosPi() {
    var config = {
      method: "get",
    //  url: 'https://run.mocky.io/v3/af60e6f5-e4b4-44cb-9c29-98b97a39d5e6',
       url:creditos+ 'creditos-preaprobados/plazos-inmediato',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      
    };

    return await axios(config);
  }


  /**
   * @author mbareiro
   * Obtiene la linea de crédito preaprobado
   * @returns 
   */
   async getLineaCredito() {
    var config = {
      method: "get",
      url: creditos + 'creditos-preaprobados/verificar-linea-credito?canal=WEB&moneda=GS&tipoLinea=LCP',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      
    };

    return await axios(config);
  }

   
   async getAutorizadorPrestamoInmediato(idLinea,socioNumero) {
     var data = JSON.stringify({
     
      idLinea:idLinea,
      numeroSocio:socioNumero
    });
    
    var config = {
      method: "post",
      url: creditos + 'creditos-preaprobados/consultar-desc-salario',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
        data: data,
    };

    return await axios(config);
  }

  /**
   * @author mbareiro
   * Obtiene si el socio está en mora en algún credito como titular o codeudor
   * @returns 
   */
   async getMoraCredito() {

    var config = {
      method: "get",
      url: creditos + 'creditos-preaprobados/consultar-mora-credito?canal=WEB',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      
    };

    return await axios(config);
  }

  /**
   * @author mbareiro
   * Obtiene el monto de la cuota
   * @returns 
   */
   async getMontoCuota(monto, plazo) {

    var _url = creditos + "creditos-preaprobados/calcular-cuota?canal=WEB&idModalidad=731&tipoGarantia=1&tipoCalculo=F&tipoCredito=P&moneda=GS";
    _url = _url + "&plazo=" + plazo + "&monto=" + monto

    var config = {
      method: "get",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      }
    };

    return await axios(config);
  }

  /**
   * @author mbareiro
   * Obtiene la mora en aporte y solidaridad del socio y conyuge
   * @returns 
   */
   async getMoraCompromiso(monto) {

    var _url = creditos + "creditos-preaprobados/consultar-mora-compromisos?canal=WEB&idModalidad=731&moneda=GS";
    _url = _url + "&monto=" + monto

    var config = {
      method: "get",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      }
    };

    return await axios(config);
  }

   /**
   * @author mbareiro
   * Obtiene la mora en aporte y solidaridad del socio y conyuge
   * @returns 
   */
   async getMoraCompromisoPi(monto, idModalidad, moneda) {

    var _url = creditos + "creditos-preaprobados/consultar-mora-compromisos?canal=WEB&idModalidad=731&moneda=GS";
    _url = _url + "&monto=" + monto

    var config = {
      method: "get",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      }
    };

    return await axios(config);
  }

  /**
   * @author mbareiro
   * Confirma la solicitud de prestamo preaprobado
   * @param {*} monto 
   * @param {*} plazo 
   * @param {*} nroSucursal 
   * @param {*} moneda 
   * @returns 
   */
  async confirmarSolicitud(monto, plazo, nroSucursal, moneda , idAhorro) {

    var data = JSON.stringify({
      canal: "WEB",
      plazoOperacion: plazo,
      idModalidad: "731",
      monto: monto,
      numeroSucursal: nroSucursal,
      moneda: moneda,
      tipoGarantia: "1",
      tipoCalculo: "F",
      tipoCredito: "P",
      tipoLinea: "LCP",
      ahorroDesembolso : idAhorro
    });
    
    var config = {
      method: "post",
      url: creditos + 'creditos-preaprobados/solicitar',
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    
    return await axios(config);
  }

  async descagarSolicitudPrestamo() {

    var _url = "socio-cuenta/get-extracto-general";
    var config = {
      method: "get",
      url: _url,
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      }
    };
    return await axios(config);

  }
}



export default new PrestamoPreaprobadoService();